var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSuccess(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.599609 24.0001C0.599609 11.0766 11.0761 0.600098 23.9996 0.600098C36.9231 0.600098 47.3996 11.0766 47.3996 24.0001C47.3996 36.9236 36.9231 47.4001 23.9996 47.4001C11.0761 47.4001 0.599609 36.9236 0.599609 24.0001ZM23.9996 2.6001C12.1807 2.6001 2.59961 12.1812 2.59961 24.0001C2.59961 35.819 12.1807 45.4001 23.9996 45.4001C35.8185 45.4001 45.3996 35.819 45.3996 24.0001C45.3996 12.1812 35.8185 2.6001 23.9996 2.6001ZM35.7198 17.3059C36.1032 17.7034 36.0917 18.3365 35.6941 18.7198L21.6941 32.2198C21.3017 32.5983 20.6784 32.5926 20.2929 32.2071L13.7929 25.7072C13.4024 25.3167 13.4024 24.6835 13.7929 24.293C14.1834 23.9025 14.8166 23.9025 15.2071 24.293L21.0127 30.0985L34.3059 17.2802C34.7034 16.8968 35.3365 16.9083 35.7198 17.3059Z",
    fill: "#00BA86"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.e0ff4362c339b5134a4800f302333290.svg";
export { ForwardRef as ReactComponent };